var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nebPill",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.closable)?_c('span',{staticClass:"nebPill-close",on:{"click":_vm.onCloseClick}},[_vm._v(" X ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }